<template>
    <div class="java-camp-h5">
        <div class="h5-head-swiper">
            <div class="swiper-container banner">
                <div class="swiper-wrapper">
                    <div class="swiper-slide slide-item1" />
                    <div class="swiper-slide slide-item2" />
                    <!-- <div class="swiper-slide slide-item3" /> -->
                </div>
            </div>
        </div>
        <div class="apply-free">
            <img
                :src="applyBtn"
                alt=""
            >
            <button
                class="apply-btn"
                @click="linkForm"
            />
        </div>

        <!-- <div class="section">
            <img class="section-img" src="https://s21.lgstatic.com/growth/activity/20210322/1616406149274.png">
        </div>
        <div class="section-btn">
            <img class="s-b-img" src="https://s21.lgstatic.com/growth/activity/20210322/1616406179206.png" @click="JumpFn()">
        </div> -->
        <div class="update-course">
          <img
            src="../assets/java-camp/h5/update-course-h5.png"
            alt=""
            >
        </div>
        <div
            v-for="(item, index) in lazyUrlList"
            :key="index"
            :class="{'moudle-block': true, 'bottom-moudle': index === 0 || index === 4 }"
        >
            <img
                v-lazy="item"
                alt=""
            >
            <button
                v-if="topBtnArr.includes(index)"
                :class="{
                    'check-lg': topBtnArr.includes(index),
                }"
                @click="toApply()"
            />
        </div>
        <div class="positions-show">
            <img
                :src="swipeTitle"
                alt=""
            >
            <div class="position-el">
                <div class="swiper-container current-wrap">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide current-slider">
                            <div class="rolling-item">
                                <div class="item item-1" />
                            </div>
                        </div>
                        <div class="swiper-slide current-slider">
                            <div class="rolling-item">
                                <div class="item item-2" />
                            </div>
                        </div>
                        <div class="swiper-slide current-slider">
                            <div class="rolling-item">
                                <div class="item item-3" />
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
        </div>
        <div
            v-for="(item1, index1) in bottomUrlList"
            :key="index1 + 10"
            :class="{
                'bottom-moudle': bottomBtnArr.includes(index1),
                'last-moudle': index1 === 5,
            }"
        >
            <img
                v-lazy="item1"
                alt=""
            >
            <button
                v-if="bottomBtnArr.includes(index1)"
                :class="{
                    'bottom-btn': bottomBtnArr.includes(index1),
                }"
                @click="toApply(index1===6)"
            />
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import applyBtn from '../assets/java-camp/h5/apply.png';
import swipeTitle from '../assets/java-camp/h5/title.jpeg';

export default {
  data() {
    return {
      applyBtn,
      swipeTitle,
      lazyUrlList: [
        require('../assets/java-camp/h5/whyJava.jpeg'),
        require('../assets/java-camp/h5/courseInfo.jpg'),
        require('../assets/java-camp/h5/project.jpg'),
        require('../assets/java-camp/h5/project1.jpg'),
        require('../assets/java-camp/h5/project2.jpg'),
        require('../assets/java-camp/h5/bigCourse.jpeg'),
        // require('../../assets/java-camp/h5/bigCourse2.jpg'),
      ],
      bottomUrlList: [
        require('../assets/java-camp/h5/javaMobile.jpg'),
        require('../assets/java-camp/h5/javaMobile1.jpg'),
        require('../assets/java-camp/h5/javaMobile2.jpg'),
        require('../assets/java-camp/h5/javaMobile3.jpg'),
        require('../assets/java-camp/h5/javaMobile4.jpg'),
        require('../assets/java-camp/h5/javaMobile5.jpg'),
        require('../assets/java-camp/h5/javaMobile6.jpg'),
      ],
      topBtnArr: [0, 4, 6], // 含有按钮的模块
      bottomBtnArr: [0, 1, 6], // 含有按钮的模块
    };
  },
  mounted() {
    this.renderHeadSwiper();
    this.renderSwiper();
  },
  methods: {
    // 轮播图
    renderHeadSwiper() {
      let headSwiperOptions = {
        direction: 'horizontal',
        loop: true,
        speed: 500,
        autoplay: 3000,
      };
      this.$nextTick(() => {
        let headSwiper = new Swiper(
          '.h5-head-swiper .swiper-container',
          headSwiperOptions
        );
        console.log(headSwiper);
      });
    },
    renderSwiper() {
      let option = {
        direction: 'horizontal',
        loop: true,
        speed: 500,
        pagination: '.current-pagination',
        paginationType: 'bullets',
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        autoplay: 3000,
        slidesPerView: 'auto',
        centeredSlides: true,
        // spaceBetween: 16,
        };
        this.$nextTick(() => {
            const swiperDom = new Swiper(
                '.position-el .swiper-container',
                option
                );
            console.log(swiperDom);
        });

    },
    linkForm() {
      handleJumpUrl('f90208644f3843e992565f3621197b83');
    },
    toApply(isLast = false) {
        if (isLast) {
            this.linkForm();
        } else {
            window.open(
                'https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2'
            );
        }

    },
    JumpFn() {
      // 点击申请调客服
      window.location.href = "https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2"
    }
  },
};
</script>
<style lang="less" scoped>
.bgUrl(@img) {
  background-image: url("../assets/java-camp/h5/@{img}");
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
}
button {
  position: absolute;
  background: transparent;
// background: red;
  border: none;
  outline: none;
}
.btn() {
  width: 394px;
  height: 75px;
  bottom: 54px;
  right: 50%;
  transform: translateX(50%);
}
.java-camp-h5 {
  font-size: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  img {
    width: 100%;
    position: relative;
  }
  .h5-head-swiper {
    .banner {
      height: 426px;
    }
    .swiper-container {
      margin: 0 auto;
      width: 100%;
      .slide-item1 {
        width: 100%;
        height: 100%;
        background: url("../assets/java-camp/h5/head-banner2.png") center
          no-repeat;
        background-size: cover;
      }
      .slide-item2 {
        width: 100%;
        height: 100%;
        background: url("../assets/java-camp/h5/head-banner1.png") center
          no-repeat;
        background-size: cover;
      }
      .slide-item3 {
        width: 100%;
        height: 100%;
        background: url("https://s21.lgstatic.com/growth/activity/20210322/1616405460403.png") center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.apply-free {
  position: relative;
  height: 64px;
  margin-bottom: 40px;
  z-index: 2;
  img {
    width: 100%;
    position: absolute;
    transform: translateY(-50%);
  }
  .apply-btn {
    width: 130px;
    height: 48px;
    right: 100px;
    top: -50%;
  }
}
.section {
    width: 100%;
    .section-img {
        width: 100%;
        display: block;
    }
}
.section-btn {
    width: 100%;
    .s-b-img {
        display: block;
        margin: 20px auto;
        width: 380px;
        height: 80px;
    }
}
.moudle-block {
    position: relative;
}
.positions-show {
  padding-bottom: 100px;
  background-color: #fff;
}
.bottom-moudle {
  position: relative;
  margin-bottom: 100px;
  text-align: center;
}
.check-lg {
  .btn();
}
.bottom-btn {
  width: 310px !important;
  .btn();
}
.last-moudle {
  margin-top: 40px;
}
/deep/.current-wrap {
  //   height: 800px;
  background-color: #efefef;
  padding-top: 50px;

  .rolling-item {
    width: 100%;
    height: 600px;
    border-radius: 0.15rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    .item-1 {
      .bgUrl("ali.png");
    }
    .item-2 {
      .bgUrl("kuaishou.png");
    }
    .item-3 {
      .bgUrl("byte.png");
    }
    .item {
      width: 600px;
      height: 467px;
      background-size: contain;
    }
  }

  .current-slider {
    width: 710px;
    height: 720px;
    padding: 20px;
    box-sizing: content-box;
    transition: all 0.3s;
    box-sizing: border-box;
  }
}

/deep/.current-pagination {
  .swiper-pagination-bullet {
    border-radius: 50%;
    width: 0.16rem;
    height: 0.173rem;
    background: #fff;
    opacity: 0.5;
    margin: 0 0.093rem;
    &-active {
      width: 0.48rem;
      height: 0.173rem;
      background: #fff;
      border-radius: 4px;
      opacity: 1;
    }
  }
}
</style>
